import {
  createDealerRequest,
  fetchDealerRequest,
  updateDealerRequest,
  fetchDealersRequest
} from "../api/index";
import { handleErrorRequest } from "../helpers/api";
import _ from "lodash";
import { createSelector } from "reselect";

const dealerState = state => state.dealers;

export const getPendingContractsAmount = createSelector(
  dealerState,
  state => {
    return _.get(state, "currentDealer.metrics.pending_diagnostic", 0);
  }
);

export const getWaitingForPickupContractsAmount = createSelector(
  dealerState,
  state => {
    return _.get(state, "currentDealer.metrics.waiting_for_pickup", 0);
  }
);

export const get30DaysRevenue = createSelector(
  dealerState,
  state => {
    return _.get(state, "currentDealer.metrics.revenue_in_last_thirty_day", 0);
  }
);

const getValue = key =>
  createSelector(
    dealerState,
    dealers => dealers[key]
  );

export const getCurrentDealer = getValue("currentDealer");
export const isLoadingFetchDealer = getValue("fetchingDealer");
export const getFailureFetchDealer = getValue("failFetchDealer");
export const isSuccessFetchDealer = getValue("successFetchDealer");

export const CREATE_DEALER_ATTEMPT = "dealers/CREATE_DEALER_ATTEMPT";
export const CREATE_DEALER_SUCCESS = "dealers/CREATE_DEALER_SUCCESS";
export const CREATE_DEALER_FAILURE = "dealers/CREATE_DEALER_FAILURE";

export const UPDATE_DEALER_ATTEMPT = "dealers/UPDATE_DEALER_ATTEMPT";
export const UPDATE_DEALER_SUCCESS = "dealers/UPDATE_DEALER_SUCCESS";
export const UPDATE_DEALER_FAILURE = "dealers/UPDATE_DEALER_FAILURE";

export const FETCH_DEALER_ATTEMPT = "dealers/FETCH_DEALER_ATTEMPT";
export const FETCH_DEALER_SUCCESS = "dealers/FETCH_DEALER_SUCCESS";
export const FETCH_DEALER_FAILURE = "dealers/FETCH_DEALER_FAILURE";

export const FETCH_DEALERS_ATTEMPT = "dealers/FETCH_DEALERS_ATTEMPT";
export const FETCH_DEALERS_SUCCESS = "dealers/FETCH_DEALERS_SUCCESS";
export const FETCH_DEALERS_FAILURE = "dealers/FETCH_DEALERS_FAILURE";

export const SET_CURRENT_DEALER = "dealers/SET_CURRENT_DEALER";
export const SET_DEALERS = "dealers/SET_DEALERS";

export const RESET_STATE = "dealers/RESET_STATE";

const createDealerAttempt = () => ({ type: CREATE_DEALER_ATTEMPT });
const createDealerSuccess = () => ({ type: CREATE_DEALER_SUCCESS });
const createDealerFailure = failMessage => ({
  type: CREATE_DEALER_FAILURE,
  failMessage
});

const updateDealerAttempt = () => ({ type: UPDATE_DEALER_ATTEMPT });
const updateDealerSuccess = () => ({ type: UPDATE_DEALER_SUCCESS });
const updateDealerFailure = failMessage => ({
  type: UPDATE_DEALER_FAILURE,
  failMessage
});

const fetchDealerAttempt = () => ({ type: FETCH_DEALER_ATTEMPT });
const fetchDealerSuccess = () => ({ type: FETCH_DEALER_SUCCESS });
const fetchDealerFailure = failMessage => ({
  type: FETCH_DEALER_FAILURE,
  failMessage
});

const fetchDealersAttempt = () => ({ type: FETCH_DEALERS_ATTEMPT });
const fetchDealersSuccess = () => ({ type: FETCH_DEALERS_SUCCESS });
const fetchDealersFailure = failMessage => ({
  type: FETCH_DEALERS_FAILURE,
  failMessage
});

export const setCurrentDealer = currentDealer => ({
  type: SET_CURRENT_DEALER,
  currentDealer
});

export const setDealers = dealers => ({ type: SET_DEALERS, dealers });

const createDealer = data => (dispatch, getState) => {
  dispatch(createDealerAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return createDealerRequest({ dealer: data }, jwt).then(
    ({ response, error }) => {
      if (response) {
        dispatch(createDealerSuccess());
        return Promise.resolve({ response });
      } else {
        dispatch(createDealerFailure(handleErrorRequest(error)));
        return Promise.resolve({ error });
      }
    }
  );
};

export const fetchDealer = dealer_id => (dispatch, getState) => {
  dispatch(fetchDealerAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return fetchDealerRequest(dealer_id, jwt).then(({ response, error }) => {
    if (response) {
      dispatch(fetchDealerSuccess());
      dispatch(setCurrentDealer(response.data));
    } else {
      dispatch(fetchDealerFailure(handleErrorRequest(error)));
    }
  });
};

export const fetchDealers = () => (dispatch, getState) => {
  dispatch(fetchDealersAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return fetchDealersRequest(jwt).then(({ response, error }) => {
    if (response) {
      dispatch(fetchDealersSuccess());
      dispatch(setDealers(response.data));
      return Promise.resolve(response.data);
    } else {
      dispatch(fetchDealersFailure(handleErrorRequest(error)));
      return Promise.reject(error);
    }
  });
};

export const fetchContactDealers = () => (dispatch, getState) => {
  dispatch(fetchDealersAttempt());
  let user = _.get(getState(), "auth.user", "");
    if (user.dealer_for_contact && user.dealer_for_contact.length > 0) {
      dispatch(fetchDealersSuccess());
      dispatch(setDealers(user.dealer_for_contact));
    }
};

const updateDealer = data => (dispatch, getState) => {
  dispatch(updateDealerAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  let dealer_id = _.get(getState(), "dealers.currentDealer.id", "");
  return updateDealerRequest(dealer_id, { dealer: data }, jwt).then(
    ({ response, error }) => {
      if (response) {
        dispatch(updateDealerSuccess());
        dispatch(setCurrentDealer(response.data));
        // const nextDealers = [..._.get(getState(), "dealers.dealers", [])];
        // const index = _.findIndex(nextDealers, { id: dealer_id });
        // nextDealers.splice(index, 1, response.data);
        // dispatch(setDealers(nextDealers));
        return Promise.resolve(response.data);
      } else {
        dispatch(updateDealerFailure(handleErrorRequest(error)));
        return Promise.reject(error);
      }
    }
  );
};

const resetState = () => ({ type: RESET_STATE });

export const actions = {
  createDealerAttempt,
  createDealerSuccess,
  createDealerFailure,
  createDealer,
  fetchDealerAttempt,
  fetchDealerSuccess,
  fetchDealerFailure,
  fetchDealer,
  fetchDealersAttempt,
  fetchDealersSuccess,
  fetchDealersFailure,
  fetchDealers,
  setDealers,
  updateDealerAttempt,
  updateDealerSuccess,
  updateDealerFailure,
  updateDealer,
  setCurrentDealer,
  resetState,
  fetchContactDealers
};

const DEALER_ACTION_HANDLERS = {
  [CREATE_DEALER_ATTEMPT]: (state, action) => ({
    ...state,
    submittingDealer: true,
    failSubmitDealer: null,
    successSubmitDealer: false
  }),
  [CREATE_DEALER_SUCCESS]: (state, action) => ({
    ...state,
    submittingDealer: false,
    failSubmitDealer: null,
    successSubmitDealer: true
  }),
  [CREATE_DEALER_FAILURE]: (state, action) => ({
    ...state,
    submittingDealer: false,
    failSubmitDealer: action.failMessage,
    successSubmitDealer: false
  }),
  [UPDATE_DEALER_ATTEMPT]: (state, action) => ({
    ...state,
    submittingDealer: true,
    failSubmitDealer: null,
    successSubmitDealer: false
  }),
  [UPDATE_DEALER_SUCCESS]: (state, action) => ({
    ...state,
    submittingDealer: false,
    failSubmitDealer: null,
    successSubmitDealer: true
  }),
  [UPDATE_DEALER_FAILURE]: (state, action) => ({
    ...state,
    submittingDealer: false,
    failSubmitDealer: action.failMessage,
    successSubmitDealer: false
  }),
  [FETCH_DEALER_ATTEMPT]: (state, action) => ({
    ...state,
    fetchingDealer: true,
    failFetchDealer: null,
    successFetchDealer: false
  }),
  [FETCH_DEALER_SUCCESS]: (state, action) => ({
    ...state,
    fetchingDealer: false,
    failFetchDealer: null,
    successFetchDealer: true
  }),
  [FETCH_DEALER_FAILURE]: (state, action) => ({
    ...state,
    fetchingDealer: false,
    failFetchDealer: action.failMessage,
    successFetchDealer: false
  }),
  [FETCH_DEALERS_ATTEMPT]: (state, action) => ({
    ...state,
    fetchingDealers: true,
    failFetchDealers: null,
    successFetchDealers: false
  }),
  [FETCH_DEALERS_SUCCESS]: (state, action) => ({
    ...state,
    fetchingDealers: false,
    failFetchDealers: null,
    successFetchDealers: true
  }),
  [FETCH_DEALERS_FAILURE]: (state, action) => ({
    ...state,
    fetchingDealers: false,
    failFetchDealers: action.failMessage,
    successFetchDealers: false
  }),
  [SET_CURRENT_DEALER]: (state, action) => ({
    ...state,
    currentDealer: action.currentDealer
  }),
  [SET_DEALERS]: (state, action) => ({ ...state, dealers: action.dealers }),
  [RESET_STATE]: (state, action) => ({
    ...state,
    ...initialState,
    ...{ dealers: state.dealers, currentDealer: state.currentDealer }
  })
};

export const initialState = {
  submittingDealer: false,
  failSubmitDealer: null,
  successSubmitDealer: false,
  fetchingDealer: false,
  failFetchDealer: null,
  successFetchDealer: false,
  currentDealer: null,
  fetchingDealers: false,
  failFetchDealers: null,
  successFetchDealers: false,
  dealers: null
};

export default function dealerReducer(state = initialState, action) {
  const handler = DEALER_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
